import React, { useMemo, useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioFluxogramaSGQPrint.css";

const ID_QUADRO_IMPRESSAO = "quadro-impressao-fluxograma-sgq";

const ESTILOS_VISUAIS = `
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq td { border: 0; border-bottom: 2px solid #dce5ef; padding: 3mm 2mm 4mm; text-align: left; }
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq td:first-child,
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq td:last-child { width: 48mm; }
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq td:nth-child(2) { text-align: center; }
.pagina-pdf-fluxograma-sgq .coluna-paginada-sgq { min-width: 0; }
.pagina-pdf-fluxograma-sgq .continuacao-coluna-sgq { margin-top: 7mm; }
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq td:nth-child(2) strong { font-size: 21px; letter-spacing: 0.4px; color: #17334f; }
.pagina-pdf-fluxograma-sgq .cabecalho-pdf-fluxograma-sgq span { color: #60758a; font-size: 11px; margin-top: 5px; }
.pagina-pdf-fluxograma-sgq .identificacao-pdf-fluxograma-sgq div { text-align: right; color: #60758a; padding: 2mm; }
.pagina-pdf-fluxograma-sgq .identificacao-pdf-fluxograma-sgq div + div { border-top: 0; }
.pagina-pdf-fluxograma-sgq .resumo-pdf-fluxograma-sgq { font-size: 10px; margin: 3mm 0 4mm; }
.pagina-pdf-fluxograma-sgq .raiz-fluxograma-sgq { width: 82mm; padding: 3mm; border: 0; border-radius: 7px; background: #17334f; font-size: 12px; letter-spacing: 0.3px; }
.pagina-pdf-fluxograma-sgq .categorias-fluxograma-sgq { grid-template-columns: repeat(var(--colunas-sgq, 8), minmax(0, 1fr)); border-top: 1px solid #b9c9d8; padding-top: 5mm; gap: 6mm 3mm; }
.pagina-pdf-fluxograma-sgq .categoria-fluxograma-sgq::before { background: #b9c9d8; }
.pagina-pdf-fluxograma-sgq .titulo-categoria-fluxograma-sgq { break-inside: avoid; page-break-inside: avoid; break-after: avoid; page-break-after: avoid; }
.pagina-pdf-fluxograma-sgq .documentos-fluxograma-sgq { break-before: avoid; page-break-before: avoid; }
.pagina-pdf-fluxograma-sgq .titulo-categoria-fluxograma-sgq { justify-content: flex-start; gap: 2mm; min-height: 14mm; box-sizing: border-box; border: 1px solid #dce5ef; border-top: 3px solid var(--cor-categoria); border-radius: 6px; padding: 2mm; background: #f3f6fa; color: #17334f; text-align: left; font-size: 12px; }
.pagina-pdf-fluxograma-sgq .numero-categoria-sgq { display: flex; align-items: center; justify-content: center; flex: 0 0 7mm; height: 7mm; border-radius: 5px; background: var(--cor-categoria); color: #fff; font-size: 12px; }
.pagina-pdf-fluxograma-sgq .titulo-categoria-fluxograma-sgq small { display: block; margin-top: 1mm; color: #64748b; font-size: 12px; font-weight: 400; }
.pagina-pdf-fluxograma-sgq .documentos-fluxograma-sgq { border-color: #cbd7e3; padding-top: 3mm; }
.pagina-pdf-fluxograma-sgq .documento-fluxograma-sgq { border: 1px solid #dce5ef; border-left: 2px solid var(--cor-categoria); border-radius: 5px; padding: 2mm; margin-bottom: 1.5mm; font-size: 12px; line-height: 1.35; color: #33485d; box-sizing: border-box; break-inside: avoid; }
.pagina-pdf-fluxograma-sgq .documento-fluxograma-sgq::before { background: #cbd7e3; }
.pagina-pdf-fluxograma-sgq .meta-documento-sgq { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 1mm; margin-bottom: 1mm; }
.pagina-pdf-fluxograma-sgq .documento-fluxograma-sgq strong { font-size: 12px; color: var(--cor-categoria); }
.pagina-pdf-fluxograma-sgq .revisao-documento-sgq { border-radius: 3px; background: #eef2f7; padding: 0.5mm 1mm; color: #52677c; font-size: 12px; white-space: nowrap; }
`;

const ESTILOS_IMPRESSAO = `
  @page { size: A3 landscape; margin: 0; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #10243a; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-fluxograma-sgq { width: 100%; padding: 10mm; box-sizing: border-box; box-decoration-break: clone; -webkit-box-decoration-break: clone; }
  .cabecalho-pdf-fluxograma-sgq { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-pdf-fluxograma-sgq td { border: 1px solid #153d64; padding: 6px; text-align: center; }
  .cabecalho-pdf-fluxograma-sgq td:first-child { width: 30mm; }
  .cabecalho-pdf-fluxograma-sgq td:last-child { width: 48mm; }
  .cabecalho-pdf-fluxograma-sgq img { max-width: 27mm; max-height: 16mm; }
  .cabecalho-pdf-fluxograma-sgq strong, .cabecalho-pdf-fluxograma-sgq span { display: block; }
  .cabecalho-pdf-fluxograma-sgq td:nth-child(2) strong { color: #0b4b78; font-size: 17px; }
  .cabecalho-pdf-fluxograma-sgq span { margin-top: 3px; font-size: 11px; }
  .identificacao-pdf-fluxograma-sgq { padding: 0 !important; }
  .identificacao-pdf-fluxograma-sgq div { padding: 6px 3px; font-size: 11px; }
  .identificacao-pdf-fluxograma-sgq div + div { border-top: 1px solid #153d64; }
  .resumo-pdf-fluxograma-sgq { margin: 2mm 0; color: #40566d; font-size: 8px; text-align: right; }
  .raiz-fluxograma-sgq { width: 72mm; margin: 0 auto; padding: 2.5mm; border: 1.5px solid #123f68; border-radius: 5px; background: #0b4774; color: #fff; font-size: 11px; font-weight: 700; text-align: center; }
  .conector-raiz-fluxograma-sgq { width: 1px; height: 5mm; margin: 0 auto; background: #5a7188; }
  .categorias-fluxograma-sgq { display: grid; grid-template-columns: repeat(8, minmax(0, 1fr)); gap: 5mm 2.5mm; align-items: start; }
  .categoria-fluxograma-sgq, .titulo-categoria-fluxograma-sgq, .documento-fluxograma-sgq { min-width: 0; white-space: normal; overflow-wrap: anywhere; word-break: normal; hyphens: auto; }
  .categoria-fluxograma-sgq { position: relative; break-inside: auto; page-break-inside: auto; }
  .categoria-fluxograma-sgq::before { content: ""; position: absolute; top: -5mm; left: 50%; width: 1px; height: 5mm; background: #5a7188; }
  .titulo-categoria-fluxograma-sgq { min-height: 10mm; display: flex; align-items: center; justify-content: center; padding: 2mm 1.5mm; border: 1px solid #153d64; border-radius: 4px; background: #dce9f4; color: #123f68; font-size: 12px; font-weight: 700; text-align: center; }
  .titulo-categoria-fluxograma-sgq small { font-size: 12px; }
  .documentos-fluxograma-sgq { margin: 0; padding: 2mm 0 0 4mm; list-style: none; border-left: 1px solid #8ba0b4; }
  .documento-fluxograma-sgq { position: relative; margin: 0 0 1.2mm; padding: 1.4mm 1.6mm; border: 1px solid #8ba0b4; border-radius: 3px; background: #fff; font-size: 12px; line-height: 1.2; }
  .documento-fluxograma-sgq::before { content: ""; position: absolute; top: 50%; left: -4mm; width: 4mm; height: 1px; background: #8ba0b4; }
  .documento-fluxograma-sgq strong, .revisao-documento-sgq { font-size: 12px; }
  .documento-fluxograma-sgq strong { display: block; color: #0b4774; }
  .sem-documentos-fluxograma-sgq { margin-top: 2mm; padding: 2mm; border: 1px dashed #9aabba; color: #66798b; font-size: 12px; text-align: center; }
`;

const texto = (valor) => String(valor ?? "").trim() || "-";

function ordenarCategorias(a, b) {
  return Number(a.ordem ?? a.codigo ?? 0) - Number(b.ordem ?? b.codigo ?? 0);
}

function ordenarDocumentos(a, b) {
  return String(a.codigoISOOrder || a.codigoISO || "").localeCompare(
    String(b.codigoISOOrder || b.codigoISO || ""),
    "pt-BR",
    { numeric: true }
  );
}

function imprimirRelatorio(elemento, nomeArquivo) {
  if (!elemento) return;
  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();

  const quadro = document.createElement("iframe");
  quadro.id = ID_QUADRO_IMPRESSAO;
  quadro.title = "Impressão do Fluxograma do SGQ";
  Object.assign(quadro.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadro);

  const janela = quadro.contentWindow;
  const documento = quadro.contentDocument;
  documento.open();
  documento.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_IMPRESSAO}${ESTILOS_VISUAIS}</style></head><body></body></html>`);
  documento.close();
  const modelo = elemento.cloneNode(true);
  modelo.style.width = "420mm";
  documento.body.appendChild(modelo);

  const imagens = Array.from(documento.images);
  Promise.all(imagens.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(async () => {
    if (documento.fonts?.ready) await documento.fonts.ready;
    paginarFluxograma(documento, modelo);
    janela.onafterprint = () => quadro.remove();
    janela.focus();
    janela.print();
  });
}

function paginarFluxograma(documento, modelo) {
  const categorias = Array.from(modelo.querySelectorAll(".categoria-fluxograma-sgq"));
  const paginas = [];
  const medida = documento.createElement("div");
  medida.style.height = "280mm";
  documento.body.appendChild(medida);
  const limiteAltura = medida.getBoundingClientRect().height;
  medida.remove();

  // O excedente aproveita o espaço livre nas colunas seguintes antes de criar outra página.
  for (let inicio = 0; inicio < Math.max(1, categorias.length); inicio += 8) {
    const grupo = categorias.slice(inicio, inicio + 8);
    const posicoes = grupo.map(() => 0);
    const itens = grupo.map(categoria => Array.from(categoria.querySelectorAll(".documento-fluxograma-sgq")));
    let continuacao = false;
    let pendentes;
    do {
      const pagina = modelo.cloneNode(true);
      const grade = pagina.querySelector(".categorias-fluxograma-sgq");
      grade.replaceChildren();
      pagina.style.setProperty("--colunas-sgq", Math.max(1, grupo.length));
      pagina.style.breakAfter = "page";
      pagina.style.pageBreakAfter = "always";
      const raiz = pagina.querySelector(".raiz-fluxograma-sgq");
      if (continuacao) raiz.textContent += " — CONTINUAÇÃO";
      documento.body.appendChild(pagina);
      const limite = pagina.getBoundingClientRect().top + limiteAltura;
      const colunas = grupo.map(() => {
        const coluna = documento.createElement("div");
        coluna.className = "coluna-paginada-sgq";
        grade.appendChild(coluna);
        return coluna;
      });
      const ultimosBlocos = [];

      grupo.forEach((categoria, indice) => {
        const coluna = categoria.cloneNode(true);
        const lista = coluna.querySelector(".documentos-fluxograma-sgq");
        if (lista) lista.replaceChildren();
        colunas[indice].appendChild(coluna);
        ultimosBlocos[indice] = coluna;
        const primeiro = posicoes[indice];
        const legenda = coluna.querySelector(".titulo-categoria-fluxograma-sgq small");
        if (continuacao && legenda) {
          legenda.textContent = primeiro < itens[indice].length ? "Continuação" : "Concluído na página anterior";
        }
        if (!lista) return;
        while (posicoes[indice] < itens[indice].length) {
          const cartao = itens[indice][posicoes[indice]].cloneNode(true);
          lista.appendChild(cartao);
          if (cartao.getBoundingClientRect().bottom > limite && posicoes[indice] > primeiro) {
            cartao.remove();
            break;
          }
          posicoes[indice] += 1;
        }
        if (legenda && posicoes[indice] < itens[indice].length) {
          legenda.textContent += " · continua";
        }
      });

      grupo.forEach((categoria, indice) => {
        for (let deslocamento = 1; deslocamento < grupo.length && posicoes[indice] < itens[indice].length; deslocamento += 1) {
          const destino = (indice + deslocamento) % grupo.length;
          const bloco = categoria.cloneNode(true);
          bloco.classList.add("continuacao-coluna-sgq");
          const lista = bloco.querySelector(".documentos-fluxograma-sgq");
          lista.replaceChildren();
          const legenda = bloco.querySelector(".titulo-categoria-fluxograma-sgq small");
          legenda.textContent = "Continuação";
          colunas[destino].appendChild(bloco);
          const primeiro = posicoes[indice];
          while (posicoes[indice] < itens[indice].length) {
            const cartao = itens[indice][posicoes[indice]].cloneNode(true);
            lista.appendChild(cartao);
            if (cartao.getBoundingClientRect().bottom > limite) {
              cartao.remove();
              break;
            }
            posicoes[indice] += 1;
          }
          if (posicoes[indice] === primeiro) {
            bloco.remove();
            continue;
          }
          const anterior = ultimosBlocos[indice].querySelector(".titulo-categoria-fluxograma-sgq small");
          anterior.textContent = `Continua na coluna ${destino + 1}`;
          ultimosBlocos[indice] = bloco;
        }
        if (posicoes[indice] < itens[indice].length) {
          ultimosBlocos[indice].querySelector(".titulo-categoria-fluxograma-sgq small").textContent = "Continua na próxima página";
        }
      });
      paginas.push(pagina);
      continuacao = true;
      pendentes = itens.some((lista, indice) => posicoes[indice] < lista.length);
    } while (pendentes);
  }

  modelo.remove();
  paginas.forEach((pagina, indice) => {
    const resumo = pagina.querySelector(".resumo-pdf-fluxograma-sgq");
    resumo.textContent += ` · Página ${indice + 1} de ${paginas.length}`;
    if (indice === paginas.length - 1) {
      pagina.style.breakAfter = "auto";
      pagina.style.pageBreakAfter = "auto";
    }
  });
}

export default function RelatorioFluxogramaSGQPrint({ categorias, documentos, onVoltar }) {
  const paginaRef = useRef(null);
  const nomeArquivo = `FLUXOGRAMA-DOCUMENTAL-SGQ-${new Date().toISOString().slice(0, 10)}`;
  useNomeArquivoPdf(nomeArquivo);

  const categoriasComDocumentos = useMemo(() => categorias
    .slice()
    .sort(ordenarCategorias)
    .map((categoria) => ({
      ...categoria,
      documentos: documentos
        .filter((documento) => String(documento.categoriaCodigo) === String(categoria.codigo))
        .sort(ordenarDocumentos),
    })), [categorias, documentos]);

  return (
    <div className="relatorio-fluxograma-sgq-print">
      <style>{ESTILOS_VISUAIS}</style>
      <div className="acoes-relatorio-fluxograma-sgq">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-fluxograma-sgq" onClick={() => imprimirRelatorio(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>

      <main ref={paginaRef} className="pagina-pdf-fluxograma-sgq" style={{ "--colunas-sgq": Math.max(1, Math.min(8, categoriasComDocumentos.length)) }}>
        <table className="cabecalho-pdf-fluxograma-sgq">
          <tbody><tr>
            <td><LogoRelatorio alt="Logo da empresa" /></td>
            <td><strong>FLUXOGRAMA DOCUMENTAL DO SGQ</strong><span>Estrutura de categorias e documentos vigentes</span></td>
            <td className="identificacao-pdf-fluxograma-sgq"><div><strong>ADMIN SGQ</strong></div><div>{new Date().toLocaleDateString("pt-BR")}</div></td>
          </tr></tbody>
        </table>

        <div className="resumo-pdf-fluxograma-sgq">{categoriasComDocumentos.length} categoria(s) · {documentos.length} documento(s)</div>
        <div className="raiz-fluxograma-sgq">SISTEMA DE GESTÃO DA QUALIDADE</div>
        <div className="conector-raiz-fluxograma-sgq" />

        <section className="categorias-fluxograma-sgq">
          {categoriasComDocumentos.map((categoria, indice) => (
            <article className="categoria-fluxograma-sgq" key={categoria.id || categoria.codigo} style={{ "--cor-categoria": ["#2563a6", "#087f8c", "#7057a3", "#b36b24", "#278466", "#ab526c"][indice % 6] }}>
              <div className="titulo-categoria-fluxograma-sgq"><span className="numero-categoria-sgq">{texto(categoria.codigo)}</span><span>{texto(categoria.titulo)}<small>{categoria.documentos.length} documento(s)</small></span></div>
              {categoria.documentos.length ? (
                <ul className="documentos-fluxograma-sgq">
                  {categoria.documentos.map((documento) => (
                    <li className="documento-fluxograma-sgq" key={documento.id}>
                      <div className="meta-documento-sgq"><strong>{texto(documento.codigoISO)}</strong>{documento.revisaoAtual != null && <span className="revisao-documento-sgq">REV. {String(documento.revisaoAtual).padStart(2, "0")}</span>}</div>
                      <span>{texto(documento.titulo)}</span>
                    </li>
                  ))}
                </ul>
              ) : <div className="sem-documentos-fluxograma-sgq">Nenhum documento ativo</div>}
            </article>
          ))}
        </section>
      </main>
    </div>
  );
}
